// Generated by Melange

import * as Buhta_payrollapis__Buhta_payroll_v1_salary from "./buhta_payroll_v1_salary.js";
import * as Buhta_payrollapis__Buhta_payroll_v1alpha2_employment from "./buhta_payroll_v1alpha2_employment.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Google_type__Google_type_date from "../../third_party/google_type/gen/google_type_date.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const UpdateEmploymentRequest = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha2_employment_service.ml",
      409,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const UpdateEmploymentResponse = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha2_employment_service.ml",
      472,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const EmploymentData = Caml_module.init_mod([
      "proto/payrollapis/gen/buhta_payroll_v1alpha2_employment_service.ml",
      538,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.payroll.v1alpha2.UpdateEmploymentRequest";
}

function make(employee_idOpt, employment, param) {
  const employee_id = employee_idOpt !== undefined ? employee_idOpt : "";
  return {
          employee_id: employee_id,
          employment: employment
        };
}

const merge_employee_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "employee_id",
            "employeeId"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_employment = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "employment",
            "employment"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: EmploymentData.name,
                make: EmploymentData.make,
                from_proto: EmploymentData.from_proto,
                from_proto_exn: EmploymentData.from_proto_exn,
                to_proto: EmploymentData.to_proto,
                to_proto$p: EmploymentData.to_proto$p,
                merge: EmploymentData.merge,
                to_json: EmploymentData.to_json,
                from_json_exn: EmploymentData.from_json_exn,
                from_json: EmploymentData.from_json
              })
        ]));

function merge(t1, t2) {
  return {
          employee_id: Curry._2(merge_employee_id, t1.employee_id, t2.employee_id),
          employment: Curry._2(merge_employment, t1.employment, t2.employment)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "employee_id",
                    "employeeId"
                  ],
                  Ocaml_protoc_plugin__Spec.string,
                  ""
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "employment",
                        "employment"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: EmploymentData.name,
                            make: EmploymentData.make,
                            from_proto: EmploymentData.from_proto,
                            from_proto_exn: EmploymentData.from_proto_exn,
                            to_proto: EmploymentData.to_proto,
                            to_proto$p: EmploymentData.to_proto$p,
                            merge: EmploymentData.merge,
                            to_json: EmploymentData.to_json,
                            from_json_exn: EmploymentData.from_json_exn,
                            from_json: EmploymentData.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._3(serialize, writer, param.employee_id, param.employment);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(employee_id, employment) {
  return {
          employee_id: employee_id,
          employment: employment
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha2.UpdateEmploymentRequest", spec(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.employee_id, param.employment);
  };
}

function constructor$1(employee_id, employment) {
  return {
          employee_id: employee_id,
          employment: employment
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha2.UpdateEmploymentRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateEmploymentRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.payroll.v1alpha2.UpdateEmploymentResponse";
}

function make$1(employment, param) {
  return {
          employment: employment
        };
}

const $$let = Buhta_payrollapis__Buhta_payroll_v1alpha2_employment.Buhta.Payroll.V1alpha2.Employment;

const merge_employment$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "employment",
            "employment"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          employment: Curry._2(merge_employment$1, t1.employment, t2.employment)
        };
}

function spec$1(param) {
  const $$let = Buhta_payrollapis__Buhta_payroll_v1alpha2_employment.Buhta.Payroll.V1alpha2.Employment;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "employment",
                    "employment"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.employment);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(employment) {
  return {
          employment: employment
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha2.UpdateEmploymentResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.employment);
  };
}

function constructor$3(employment) {
  return {
          employment: employment
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha2.UpdateEmploymentResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, UpdateEmploymentResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.payroll.v1alpha2.EmploymentData";
}

function make$2(start_date, terminate_date, positionOpt, salary_typeOpt, salary_periodOpt, salary_methodOpt, salary_rateOpt, param) {
  const position = positionOpt !== undefined ? positionOpt : "";
  const salary_type = salary_typeOpt !== undefined ? salary_typeOpt : Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryType.from_int_exn, 0);
  const salary_period = salary_periodOpt !== undefined ? salary_periodOpt : Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryPeriod.from_int_exn, 0);
  const salary_method = salary_methodOpt !== undefined ? salary_methodOpt : Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryMethod.from_int_exn, 0);
  const salary_rate = salary_rateOpt !== undefined ? salary_rateOpt : "";
  return {
          start_date: start_date,
          terminate_date: terminate_date,
          position: position,
          salary_type: salary_type,
          salary_period: salary_period,
          salary_method: salary_method,
          salary_rate: salary_rate
        };
}

const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_start_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "start_date",
            "startDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

const $$let$2 = Google_type__Google_type_date.Google.Type.$$Date;

const merge_terminate_date = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "terminate_date",
            "terminateDate"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              })
        ]));

const merge_position = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            3,
            "position",
            "position"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_salary_type = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            4,
            "salary_type",
            "salaryType"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryType),
          Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryType.from_int_exn, 0)
        ]));

const merge_salary_period = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            5,
            "salary_period",
            "salaryPeriod"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryPeriod),
          Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryPeriod.from_int_exn, 0)
        ]));

const merge_salary_method = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            6,
            "salary_method",
            "salaryMethod"
          ],
          Ocaml_protoc_plugin__Spec.$$enum(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryMethod),
          Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryMethod.from_int_exn, 0)
        ]));

const merge_salary_rate = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            7,
            "salary_rate",
            "salaryRate"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

function merge$2(t1, t2) {
  return {
          start_date: Curry._2(merge_start_date, t1.start_date, t2.start_date),
          terminate_date: Curry._2(merge_terminate_date, t1.terminate_date, t2.terminate_date),
          position: Curry._2(merge_position, t1.position, t2.position),
          salary_type: Curry._2(merge_salary_type, t1.salary_type, t2.salary_type),
          salary_period: Curry._2(merge_salary_period, t1.salary_period, t2.salary_period),
          salary_method: Curry._2(merge_salary_method, t1.salary_method, t2.salary_method),
          salary_rate: Curry._2(merge_salary_rate, t1.salary_rate, t2.salary_rate)
        };
}

function spec$2(param) {
  const $$let = Google_type__Google_type_date.Google.Type.$$Date;
  const $$let$1 = Google_type__Google_type_date.Google.Type.$$Date;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "start_date",
                    "startDate"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "terminate_date",
                        "terminateDate"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let$1.name,
                            make: $$let$1.make,
                            from_proto: $$let$1.from_proto,
                            from_proto_exn: $$let$1.from_proto_exn,
                            to_proto: $$let$1.to_proto,
                            to_proto$p: $$let$1.to_proto$p,
                            merge: $$let$1.merge,
                            to_json: $$let$1.to_json,
                            from_json_exn: $$let$1.from_json_exn,
                            from_json: $$let$1.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                          [
                            3,
                            "position",
                            "position"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          ""
                        ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                              [
                                4,
                                "salary_type",
                                "salaryType"
                              ],
                              Ocaml_protoc_plugin__Spec.$$enum(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryType),
                              Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryType.from_int_exn, 0)
                            ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                  [
                                    5,
                                    "salary_period",
                                    "salaryPeriod"
                                  ],
                                  Ocaml_protoc_plugin__Spec.$$enum(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryPeriod),
                                  Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryPeriod.from_int_exn, 0)
                                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                      [
                                        6,
                                        "salary_method",
                                        "salaryMethod"
                                      ],
                                      Ocaml_protoc_plugin__Spec.$$enum(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryMethod),
                                      Curry._1(Buhta_payrollapis__Buhta_payroll_v1_salary.Buhta.Payroll.V1.SalaryMethod.from_int_exn, 0)
                                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                                          [
                                            7,
                                            "salary_rate",
                                            "salaryRate"
                                          ],
                                          Ocaml_protoc_plugin__Spec.string,
                                          ""
                                        ]), Ocaml_protoc_plugin__Spec.nil)))))));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._8(serialize$2, writer, param.start_date, param.terminate_date, param.position, param.salary_type, param.salary_period, param.salary_method, param.salary_rate);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(start_date, terminate_date, position, salary_type, salary_period, salary_method, salary_rate) {
  return {
          start_date: start_date,
          terminate_date: terminate_date,
          position: position,
          salary_type: salary_type,
          salary_period: salary_period,
          salary_method: salary_method,
          salary_rate: salary_rate
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.payroll.v1alpha2.EmploymentData", spec$2(undefined))(options);
  return function (param) {
    return Curry._7(serialize, param.start_date, param.terminate_date, param.position, param.salary_type, param.salary_period, param.salary_method, param.salary_rate);
  };
}

function constructor$5(start_date, terminate_date, position, salary_type, salary_period, salary_method, salary_rate) {
  return {
          start_date: start_date,
          terminate_date: terminate_date,
          position: position,
          salary_type: salary_type,
          salary_period: salary_period,
          salary_method: salary_method,
          salary_rate: salary_rate
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.payroll.v1alpha2.EmploymentData", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, EmploymentData, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

const updateEmployment_0 = {
  name: UpdateEmploymentRequest.name,
  make: UpdateEmploymentRequest.make,
  from_proto: UpdateEmploymentRequest.from_proto,
  from_proto_exn: UpdateEmploymentRequest.from_proto_exn,
  to_proto: UpdateEmploymentRequest.to_proto,
  to_proto$p: UpdateEmploymentRequest.to_proto$p,
  merge: UpdateEmploymentRequest.merge,
  to_json: UpdateEmploymentRequest.to_json,
  from_json_exn: UpdateEmploymentRequest.from_json_exn,
  from_json: UpdateEmploymentRequest.from_json
};

const updateEmployment_1 = {
  name: UpdateEmploymentResponse.name,
  make: UpdateEmploymentResponse.make,
  from_proto: UpdateEmploymentResponse.from_proto,
  from_proto_exn: UpdateEmploymentResponse.from_proto_exn,
  to_proto: UpdateEmploymentResponse.to_proto,
  to_proto$p: UpdateEmploymentResponse.to_proto$p,
  merge: UpdateEmploymentResponse.merge,
  to_json: UpdateEmploymentResponse.to_json,
  from_json_exn: UpdateEmploymentResponse.from_json_exn,
  from_json: UpdateEmploymentResponse.from_json
};

const updateEmployment = [
  updateEmployment_0,
  updateEmployment_1
];

const V1alpha2_EmploymentService = {
  UpdateEmployment: {
    name: "/buhta.payroll.v1alpha2.EmploymentService/UpdateEmployment",
    package_name: "buhta.payroll.v1alpha2",
    service_name: "EmploymentService",
    method_name: "UpdateEmployment",
    $$Request: {
      name: UpdateEmploymentRequest.name,
      make: UpdateEmploymentRequest.make,
      from_proto: UpdateEmploymentRequest.from_proto,
      from_proto_exn: UpdateEmploymentRequest.from_proto_exn,
      to_proto: UpdateEmploymentRequest.to_proto,
      to_proto$p: UpdateEmploymentRequest.to_proto$p,
      merge: UpdateEmploymentRequest.merge,
      to_json: UpdateEmploymentRequest.to_json,
      from_json_exn: UpdateEmploymentRequest.from_json_exn,
      from_json: UpdateEmploymentRequest.from_json
    },
    $$Response: {
      name: UpdateEmploymentResponse.name,
      make: UpdateEmploymentResponse.make,
      from_proto: UpdateEmploymentResponse.from_proto,
      from_proto_exn: UpdateEmploymentResponse.from_proto_exn,
      to_proto: UpdateEmploymentResponse.to_proto,
      to_proto$p: UpdateEmploymentResponse.to_proto$p,
      merge: UpdateEmploymentResponse.merge,
      to_json: UpdateEmploymentResponse.to_json,
      from_json_exn: UpdateEmploymentResponse.from_json_exn,
      from_json: UpdateEmploymentResponse.from_json
    }
  },
  updateEmployment: updateEmployment
};

const V1alpha2 = {
  UpdateEmploymentRequest: UpdateEmploymentRequest,
  UpdateEmploymentResponse: UpdateEmploymentResponse,
  EmploymentData: EmploymentData,
  EmploymentService: V1alpha2_EmploymentService
};

const Payroll = {
  V1alpha2: V1alpha2
};

const Buhta = {
  Payroll: Payroll
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* UpdateEmploymentRequest Not a pure module */
